/* eslint-disable no-undef */

class HotspotsDrawerProducts extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['container', 'productTemplate']
  }

  static get requiredExternalElements () {
    return ['hotspotLink']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()
    this.setupHotspots()
  }

  setupHotspots () {
    this.externalEls.hotspotLink.elements.forEach(hotspot => {
      this.listeners.add(hotspot, 'click', e =>
        this.handleHotspotClick(e, hotspot),
      )
    })
  }

  handleHotspotClick (e, hotspot) {
    if (hotspot.tagName === 'A' || hotspot.hasAttribute('href')) {
      e.preventDefault()
    }

    // Get the product handle from the clicked hotspot
    const hotspotContainer = hotspot.closest('.sec-HeroSlide_Hotspot')
    const productHandle = hotspotContainer.getAttribute('data-product-handle')

    if (!productHandle) {
      console.error('No product handle found on hotspot')
      this.els.container.element.innerHTML = '<p>Product not found</p>'
      return
    }

    const slide = hotspot.closest('.sec-Hero_Slide')
    const slideIndex = parseInt(slide?.getAttribute('data-slide-index'))
    const sectionId = hotspot.dataset.id

    // Clear existing products
    this.els.container.element.innerHTML = ''

    // Get the current viewport
    const viewportMobile = window.innerWidth <= 768

    // Find the specific product that was clicked
    const slideProducts = slide
      ? window.heroSlideProducts[slideIndex]
      : window.hotspotProducts[sectionId]
    const clickedProduct = slideProducts.find(product => {
      return product.handle === productHandle
    })

    if (!clickedProduct) {
      console.error(
        'Product not found:',
        productHandle,
        'for viewport:',
        viewportMobile ? 'mobile' : 'desktop',
      )
      this.els.container.element.innerHTML =
        '<p>Product not available for this viewport</p>'
      return
    }

    // Render only the clicked product
    this.renderProductCard(clickedProduct)
  }

  async renderProductCard (productData) {
    try {
      // Create a new product card container
      const productCard = this.els.productTemplate.element.content
        .cloneNode(true)
        .querySelector('.drw-Drawer_HotspotProductsContent')

      if (!productCard) {
        console.error(
          'Could not find product template element with class .drw-Drawer_HotspotProductsContent',
        )
        return
      }

      productCard.innerHTML =
        '<div class="sec-HeroDrawer_Loading">Loading...</div>'
      this.els.container.element.appendChild(productCard)

      // Fetch the rendered product card HTML
      const response = await fetch(
        `/products/${productData.handle}?view=card&section_id=product-card-hotspots`,
      )

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const html = await response.text()

      // Extract just the product card HTML from the response
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = html

      const productCardElement = tempDiv.querySelector('.prd-CardHotspots')

      if (!productCardElement) {
        console.error('Could not find .prd-CardHotspots in response HTML')
        throw new Error('Product card element not found in response')
      }

      const productCardHtml = productCardElement.innerHTML

      // Update the product card container with the rendered HTML
      productCard.innerHTML = productCardHtml

      // Initialize any needed functionality (quick add, etc.)
      if (typeof initProductCardFunctionality === 'function') {
        initProductCardFunctionality(productCard)
      }
    } catch (error) {
      console.error('Error rendering product card:', error)

      // Show error in card
      const productCard = this.els.productTemplate.element.content
        .cloneNode(true)
        .querySelector('.drw-Drawer_HotspotProductsContent')

      if (productCard) {
        productCard.innerHTML = `<div class="sec-HeroDrawer_Error">Error loading product: ${productData.title}<br>Error: ${error.message}</div>`
        this.els.container.element.appendChild(productCard)
      }
    }
  }
}

customElements.define('hotspots-drawer-products', HotspotsDrawerProducts)
